export default __webpack_public_path__ + "static/media/arvest.37b8fa7c.png";